module.exports = __webpack_public_path__ + "static/media/ddicon.f05e827c.svg";